jQuery( document ).ready(
	function( $ ) {
		const kycCheckId = $( '*[data-kyc-check-id]' ).data( 'kycCheckId' );
		const redirectTo = $( '*[data-kyc-check-id]' ).data( 'redirectTo' );
		const $contractAccessLikeBtn = $( '.contract-access-link-btn' );
		const $validationNeeded = $( '.kyc-validation-needed' );
		const $verificationInProgress = $( '.kyc-verification-in-progress' );
		const $verificationComplete = $( '.kyc-verification-complete' );
		const $verificationTimeout = $( '.kyc-verification-timeout' );
		let checkInterval = null;

		$contractAccessLikeBtn.click( function() {
			showVerificationInProgress();

			let counter = 0;
			checkInterval = setInterval( function() {
				if ( counter > 200 ) {
					showVerificationTimeout();
					clearInterval( checkInterval );
				}
				checkKycState();
				counter++;
			}, 3000 );
		} );

		function checkKycState() {
			// eslint-disable-next-line camelcase,no-undef
			const { ajaxUrl, nonce, action } = check_contract_post_state;
			$.ajax( {
				type: 'post',
				dataType: 'json',
				url: ajaxUrl,
				data: {
					action,
					nonce,
					kyc_check_id: kycCheckId,
				},
				success( res ) {
					if ( res.clientSignedAt ) {
						clearInterval( checkInterval );
						showVerificationComplete();
						setTimeout( () => window.location.href = redirectTo, 1500 );
					}
				},
				error( err ) {
					// eslint-disable-next-line no-console
					console.error( err );
				},
			} );
		}

		function showVerificationInProgress() {
			$validationNeeded.hide();
			$verificationInProgress.show();
			$( 'body' ).Circlebar( {
				element: '.timer-circle',
				maxValue: 600,
				fontSize: '16px',
				fontColor: '#000000',
				dialWidth: 5,
				size: '114px',
			} );
		}

		function showVerificationComplete() {
			$verificationInProgress.hide();
			$verificationComplete.show();
		}

		function showVerificationTimeout() {
			$verificationInProgress.hide();
			$verificationTimeout.show();
		}
	}
);
